




































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import PaycheckStatus from './PaycheckStatus.vue';
import ShowPdfButton from '@/components/Invoicing/Shared/Buttons/ShowPdfButton.vue';

import PermissionService from '@/utils/permission-service';
import formatPaycheckNumber from '@/filters/formatPaycheckNumber';

import { PAYCHECKS_SEARCH, PAYCHECK_PDF } from '@/queries/Paycheck';
import { GQL_paychecksSearch_paychecks } from '@/queries/__generated__/paychecksSearch';

interface IColumnsSelection {
  number: boolean;
  employee: boolean;
  journalDate: boolean;
  startDate: boolean;
  endDate: boolean;
  locked: boolean;
  paidDate: boolean;
  reported: boolean;
  reportedDate: boolean;
  advancedMode: boolean;
  controls: boolean;
}

@Component({
  components: {
    ShowPdfButton,
    PaycheckStatus,
  },
})
export default class PaycheckList extends Vue {
  private PAYCHECKS_SEARCH = PAYCHECKS_SEARCH;
  private PermissionService = PermissionService;
  private PAYCHECK_PDF = PAYCHECK_PDF;
  private formatPaycheckNumber = formatPaycheckNumber;
  private selectedPaychecks: GQL_paychecksSearch_paychecks[] = [];

  private baseColumns: IColumnsSelection = {
    number:true,
    employee:true,
    journalDate:true,
    startDate:true,
    endDate:true,
    locked:true,
    paidDate:true,
    reported:true,
    reportedDate:true,
    advancedMode:false,
    controls:true,
  }
  @Prop({type: Object, required: false, default: () => {}}) private columns? : IColumnsSelection;


  private get showColumns(){
    return {
      ...this.baseColumns,
      ...this.columns,
    };
  }
}
